import { render } from "./help-and-support-block.vue?vue&type=template&id=39cd5190&ts=true"
import script from "./help-and-support-block.ts?vue&type=script&lang=ts&external"
export * from "./help-and-support-block.ts?vue&type=script&lang=ts&external"

import "./help-and-support-block.scss?vue&type=style&index=0&lang=scss&external"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__